import { ActionButton as FabricActionButton } from "@fluentui/react";

export const ActionButton = FabricActionButton;
